import CriticsIcon from '~/components/modules/Critics/CriticsIcon';
import { Heading } from '~/vinovest-design-system/components';
import type { CMSCritic } from '~/networking/api/cms/responses/CMSWineVintage';

interface WineCriticProps {
    wineCritic: CMSCritic[];
}

/** Displays all critic reviews and scores for a particular asset. */
export const WineCritic = ({ wineCritic }: WineCriticProps) => {
    return (
        <div className={'mb-10'}>
            <Heading level={'h2'} classnames={'mb-5'}>
                Critics Scores
            </Heading>
            <div>
                {wineCritic.map((critic, index) => {
                    return (
                        <div
                            key={critic.id}
                            className={`flex flex-col lg:flex-row rounded mb-5 p-6 lg:py-6 pl-3 pr-6 ${
                                background[index % 4]
                            }`}
                        >
                            <div className={'w-auto'}>
                                <div className={'relative w-32 h-32 lg:mr-4 lg:p-3'}>
                                    <CriticsIcon name={critic.name} score={critic.score} index={index} />
                                </div>
                            </div>
                            <div className={'flex-grow'}>
                                <Heading
                                    level={'h3'}
                                    type={'h5'}
                                    className={`capitalize font-normal font-roslindale py-4 sm:text-24 text-20 ${text[index]}`}
                                >
                                    {critic.name}
                                </Heading>
                                <p className={`leading-loose text-13 ${text[index]}`}>{critic.description}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const background: { [key: number]: string } = {
    0: 'bg-[#F5F5F3]',
    1: 'bg-[#FBF8F5]',
    2: 'bg-[#F3F5F6]',
    3: 'bg-[#F6F4F4]'
};

const text: { [key: number]: string } = {
    0: 'text-turtleGreen-800',
    1: 'text-brown-600',
    2: 'text-blue-800',
    3: 'text-[#4F1C28] '
};
